import Layout from '../components/layout/Layout';

const ContactPage = () => {
  return (
    <Layout>
      <div className="py-10">
        <div className="container-custom">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Contacto</h1>

          <div className="mt-6 space-y-6 text-gray-700 dark:text-gray-300 leading-relaxed">
            <p>
              Para consultas comerciales, soporte, reportes o solicitudes relacionadas con Illustra, podés escribirnos a:
            </p>

            <div className="rounded-2xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-5">
              <div className="text-sm text-gray-600 dark:text-gray-400">Email de negocio</div>
              <a
                href="mailto:illustra.contacto@gmail.com"
                className="mt-2 inline-block text-lg font-semibold text-indigo-600 dark:text-indigo-400 hover:underline"
              >
                illustra.contacto@gmail.com
              </a>
              <p className="mt-3 text-sm text-gray-600 dark:text-gray-400">
                Tiempo de respuesta estimado: 24–72 horas hábiles.
              </p>
            </div>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Qué incluir en tu mensaje</h2>
              <ul className="mt-3 space-y-2 text-sm text-gray-700 dark:text-gray-300">
                <li>- Tu usuario o email con el que te registraste (si aplica).</li>
                <li>- Una descripción clara del problema o solicitud.</li>
                <li>- Capturas de pantalla o links relevantes.</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContactPage;

